import React, { useEffect, useMemo, useState } from 'react'
import { Button, Checkbox, Dropdown, Icon, Input, Loader, Modal, TextArea } from 'semantic-ui-react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { html as beautifyHtml } from 'js-beautify';
import { ToastContainer, toast } from 'react-toastify';
import {
    getSecaoListAction,
    getSecaoSKUListAction,
    getConteudoListAction,
    getConteudoDetalhesAction,
    getClassificacaoListAction,
    getFabricanteListAction,
    getMarcaListAction,
    getLinhaListAction,
    getConteudoBuscaAction,
    getConteudoAplicaAction,
    postUpdateDescConteudo,
    postUpdateTituloConteudo,
    postNewTitulo,
    postDeleteTitulo,
    SearchSKUAction
} from '../../../actions/EspacoTecaActions';


const Container = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  height: 300px;
  border: 1px solid #dededf;
  border-radius: 8px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f2f3f5;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 8px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.9rem;
`;

const Th = styled.th`
  text-align: left;
  background: #102E3E;
  padding: 10px;
  color: #fff;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Td = styled.td`
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  color: #444;
  vertical-align: middle;
`;

const Status = styled.span`
  width: '200px';
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 500;
  color: ${(props) =>
        props.value === "<vazio>"
            ? "#fff"
            : props.value === props.valorParaInput
                ? "#1a421a"
                : "#222"};
  background-color: ${(props) =>
        props.value === "<vazio>"
            ? "#e63946"
            : props.value === props.valorParaInput
                ? "#b7e4c7"
                : "#ffb703"};
`;

const ActionButton = styled(Button)`
  && {
    color: white;
    background-color: #D73A49;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.85rem;
  }

  &&:hover {
    background-color: #B12E3B;
    color: white;
  }
`;
const ActionButtonSelect = styled(Button)`
  && {
    color: white !important;
    background-color: ${({ selected }) => (selected ? '#D73A49' : '#0078d7')} !important;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.85rem;
    transition: background-color 0.15s ease;
  }

  &&:hover {
    background-color: ${({ selected }) => (selected ? '#B12E3B' : '#005ea3')} !important;
    color: white !important;
  }

  &&:focus,
  &&:active {
    background-color: ${({ selected }) => (selected ? '#D73A49' : '#0078d7')} !important;
    color: white !important;
    box-shadow: none !important;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: #f8f9fb;
  border-top: 1px solid #dededf;
`;

const ApplyButton = styled(Button)`
  && {
    background: #0078d7;
    color: white;
    font-weight: 600;
    border-radius: 6px;
    padding: 8px 16px;
  }

  &&:hover {
    background: #005ea3;
  }
`;

const StyledModalHeader = styled(Modal.Header)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 0 !important;
  border-bottom: none !important;
`;

const ModalTitle = styled.h2`
  font-weight: 700 !important;
  margin-top: '10px' !important;
  margin-bottom: 1em !important;
`;

const StyledModalContent = styled(Modal.Content)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
`;

const StyledModalActions = styled(Modal.Actions)`
  display: flex !important;
  justify-content: center !important;
  gap: 1rem !important;
  padding-bottom: 2em !important;
  border-top: none !important;
`;

const Tr = styled.tr`
  background-color: ${({ selected }) => (selected ? '#e6f3ff' : 'transparent')};
  transition: background-color 0.2s ease-in-out;
`;

const CustomDropdown = styled(Dropdown)`
  &.ui.selection.dropdown:focus,
  &.ui.selection.dropdown.active {
    border-color: #102E3E !important;
    box-shadow: 0 0 0 1px #102E3E !important;
  }

  &.ui.selection.dropdown.active .dropdown.icon {
    color: #102E3E !important;
  }

  &.ui.selection.dropdown .menu {
    max-height: 320px !important;
    overflow-y: auto !important;
    border: 2px solid #102E3E !important;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
  }
`;

const normalizeProductName = (name) => (name || '')
    .replace(/^\([^)]*\):\s*/, '')
    .replace(/\s+[A-Za-z]+[A-Za-z0-9]*-[A-Za-z0-9-]+$/, '');

const getReferencia = (item) => item?.referencia || item?.titulo || '';

const getConteudoEditForm = (item = {}) => ({
    descricaocurta: item?.descricaocurta || '',
    descricaolonga: item?.descricaolonga || '',
    urlpdf: item?.urlpdf || '',
    urlvideo: item?.urlvideo || '',
    urlfoto: item?.urlfoto || '',
    iconesvg: item?.iconesvg || '',
    videoembed: item?.videoembed || '',
    textoalternativo: item?.textoalternativo || '',
    legenda: item?.legenda || '',
    legendadescritiva: item?.legendadescritiva || '',
    ordem: item?.ordem || ''
});


function Conteudo(props) {

    const [filtros, setFiltros] = useState({
        tecasecaoid: '',
        tecasecao: ''
    });
    const [filtrosFabricante, setFiltrosFabricante] = useState({
        tecafabricanteid: '',
        tecafabricante: ''
    });
    const [filtrosMarca, setFiltrosMarca] = useState({
        tecamarcaid: '',
        tecamarca: ''
    });
    const [filtrosLinha, setFiltrosLinha] = useState({
        tecalinhaid: '',
        tecalinha: ''
    });
    const [filtrosClassificacao, setFiltrosClassificacao] = useState({
        classificacaoid: '',
        classificacao: ''
    });
    const [filtrosClassificacaoAplica, setFiltrosClassificacaoAplica] = useState({
        classificacaoid: '',
        classificacao: ''
    });
    const [selecionado, setSelecionado] = useState();
    const [tituloSelecionado, setTituloSelecionado] = useState();
    const [adicionar, setAdicionar] = useState(false);
    const [editar, setEditar] = useState(false);
    const [novoTitulo, setNovoTitulo] = useState('');
    const [atributosOriginais, setAtributosOriginais] = useState([]);
    const [atributosLocais, setAtributosLocais] = useState([]);
    const [sku, setSku] = useState('');
    const [skuProdutoNome, setSkuProdutoNome] = useState('');
    const [skuSearch, setSkuSearch] = useState('');
    const [produto, setProduto] = useState('');
    const [skuAplica, setSkuAplica] = useState('');
    const [produtoAplica, setProdutoAplica] = useState('');
    const [titulo, setTitulo] = useState('');
    const [usarMesmoValor, setUsarMesmoValor] = useState(false);
    const [selecionados, setSelecionados] = useState([]);
    const [buscaTitulo, setBuscaTitulo] = useState('');
    const [selectedConteudoIds, setSelectedConteudoIds] = useState([]);
    const [openModalExcluirSKU, setOpenModalExcluirSKU] = useState(false)
    const [tituloExcluir, setTituloExcluir] = useState('');
    const [conteudoExcluir, setConteudoExcluir] = useState();
    const [editarTituloId, setEditarTituloId] = useState(null);

    const { getSecaoListAction, getConteudoListAction, getClassificacaoListAction, getFabricanteListAction,
        getMarcaListAction, getLinhaListAction, getConteudoDetalhesAction, getConteudoBuscaAction, getConteudoAplicaAction, getSecaoSKUListAction,
        postUpdateDescConteudo, postUpdateTituloConteudo, postNewTitulo, postDeleteTitulo, SearchSKUAction } = props;
    const { secaolist, linhalist, linhalistLoading, secaolistLoading, conteudolist, conteudolistLoading, fabricanteList, fabricanteListLoading, marcaList,
        classificacaoList, classificacaoListLoading, conteudobusca, conteudobuscaLoading, conteudoaplica, conteudoaplicaLoading,
        secaoskulist, secaoskulistLoading, updatedesc, updatedescloading, updatetitulo, updatetituloloading,
        addtitulo, addtituloloading, deletetitulo, deletetituloloading, conteudodetalhes, conteudodetalhesLoading } = props;

    const secaoOptions = secaolist?.map((item) => ({
        key: item.tecasecaoid,
        text: item.tecasecao,
        value: item.tecasecaoid
    })) || [];

    const searchSecaoOptions = (options, query) => {
        const selectedText = secaoOptions.find((item) => item.value === filtros.tecasecaoid)?.text || '';
        const normalizedQuery = (query || '').trim().toLowerCase();

        if (!normalizedQuery || (selectedText && selectedText.toLowerCase().includes(normalizedQuery))) {
            return options;
        }

        return options.filter((item) => String(item.text || '').toLowerCase().includes(normalizedQuery));
    };

    const secaoskuOptions = secaoskulist?.map((item, index) => ({
        key: `${item.tecasecaoid}-${item.tecaconteudoid || index}`,
        text: item.tecasecao,
        value: item.tecasecaoid
    })) || [];

    const activeSecaoOptions = skuSearch.trim() && secaoskulist.length > 0 ? secaoskuOptions : secaoOptions;

    const [value, setValue] = useState('');

    const [htmlMode, setHtmlMode] = useState(false);
    const [conteudoHtml, setConteudoHtml] = useState('');
    const [conteudoEditForm, setConteudoEditForm] = useState(getConteudoEditForm());


    useEffect(() => {
        getSecaoListAction();
        getClassificacaoListAction();
        getFabricanteListAction();
        // getMarcaListAction();
    }, []);

    const handleChange = (e, { value }) => {
        const secaoSkuSelecionada = secaoskulist.find((item) => item.tecasecaoid === value);

        setFiltros(prev => ({
            ...prev,
            tecasecaoid: value
        }));

        setBuscaTitulo(skuSearch.trim() && secaoSkuSelecionada ? getReferencia(secaoSkuSelecionada) : '');

        getConteudoListAction(value);

        getConteudoBuscaAction({
            tecafabricanteid: null,
            tecamarcaid: null,
            tecalinhaid: null,
            classificacaoid: null,
            sku: null,
            produto: '',
            titulo: '',
            tecasecaoid: value
        });

    };

    const selecionadoList = conteudodetalhes.find((item) => item.tecaconteudoid === selecionado);


    useEffect(() => {
        const form = getConteudoEditForm(selecionadoList);
        setConteudoEditForm(form);
        setConteudoHtml(form.descricaolonga);
        setEditar(false);
    }, [conteudodetalhes, selecionado]);

    const handleConteudoFieldChange = (field, value) => {
        setConteudoEditForm(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleCancelarEdicaoConteudo = () => {
        const form = getConteudoEditForm(selecionadoList);
        setConteudoEditForm(form);
        setConteudoHtml(form.descricaolonga);
        setEditar(false);
    };



    const handleSelect = (id, referencia) => {
        if (selecionado === id) {
            setSelecionado(null);
        } else {

            setSelecionado(id);
            setTituloSelecionado(referencia)
            getConteudoDetalhesAction({ tecasecaoid: filtros.tecasecaoid, tecaconteudoid: id });
        }
        handleBuscarAplica(referencia);
    }

    const handleSaveTitulo = async () => {
        console.log('Salvar nova referencia:', novoTitulo, 'secaoid:', filtros.tecasecaoid);

        try {
            const res = await postNewTitulo({
                tecasecaoid: filtros.tecasecaoid,
                titulo: novoTitulo
            });

            // console.log('status ->', res?.[0]?.status);

            if (res?.[0]?.status === 'OK') {
                toast.success(res[0].message || 'Referência adicionada com sucesso!');
                setAdicionar(false);
                getConteudoListAction(filtros.tecasecaoid);
            } else {
                toast.error(res?.[0]?.message || 'Erro ao adicionar referência!');
                setAdicionar(false);
            }

        } catch (error) {
            toast.error('Erro ao adicionar referência!');
            console.error(error);
        }
    }

    const fabricanteOptions = fabricanteList?.map((item) => ({
        key: item.tecafabricanteid,
        text: item.tecafabricante,
        value: item.tecafabricanteid
    })) || [];

    const marcaOptions = marcaList?.map((item) => ({
        key: item.tecamarcaid,
        text: item.tecamarca,
        value: item.tecamarcaid
    })) || [];

    const classificacaoOptions = classificacaoList?.map((item) => ({
        key: item.classificacaoid,
        text: item.classificacao,
        value: item.classificacaoid
    })) || [];

    const linhaOptions = linhalist?.map((item) => ({
        key: item.tecalinhaid,
        text: item.tecalinha,
        value: item.tecalinhaid
    })) || [];

    const handleChangeFabricante = (e, { value }) => {

        console.log('value ->', value)
        console.log('id ->', e)

        if (!value) {
            const novo = {
                tecafabricanteid: '',
                tecafabricante: ''
            };
            setFiltrosFabricante(novo);
            setAtributosLocais(atributosOriginais); // restaura lista local
            return;
        }

        const atributoSelecionado = fabricanteOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecafabricanteid: atributoSelecionado?.key || '',
            tecafabricante: atributoSelecionado?.text || '',
        };

        setFiltrosFabricante(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getMarcaListAction({ tecafabricanteid: novoFiltros.tecafabricanteid });
    };

    const handleChangeMarca = (e, { value }) => {

        console.log('value ->', value)
        console.log('id ->', e)

        if (!value) {
            const novo = {
                tecamarcaid: '',
                tecamarca: ''
            };
            setFiltrosMarca(novo);
            setAtributosLocais(atributosOriginais); // restaura lista local
            return;
        }

        const atributoSelecionado = marcaOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecamarcaid: atributoSelecionado?.key || '',
            tecamarca: atributoSelecionado?.text || '',
        };

        setFiltrosMarca(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };

    const handleChangeLinha = (e, { value }) => {
        if (!value) {
            const novo = {
                tecalinhaid: '',
                tecalinha: ''
            };
            setFiltrosLinha(novo);
            setAtributosLocais(atributosOriginais); // restaura lista local
            return;
        }

        const atributoSelecionado = linhaOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecalinhaid: atributoSelecionado?.key || '',
            tecalinha: atributoSelecionado?.text || '',
        };

        setFiltrosLinha(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        // getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };

    const handleChangeClassificacao = (e, { value }) => {
        if (!value) {
            const novo = {
                classificacaoid: '',
                classificacao: ''
            };
            setFiltrosClassificacao(novo);
            setAtributosLocais(atributosOriginais); // restaura lista local
            return;
        }

        const atributoSelecionado = classificacaoOptions.find(opt => opt.value === value);

        const novoFiltros = {
            classificacaoid: atributoSelecionado?.key || '',
            classificacao: atributoSelecionado?.text || '',
        };

        setFiltrosClassificacao(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        // getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };

    const handleChangeClassificacaoAplica = (e, { value }) => {
        if (!value) {
            const novo = {
                classificacaoid: '',
                classificacao: ''
            };
            setFiltrosClassificacaoAplica(novo);
            setAtributosLocais(atributosOriginais); // restaura lista local
            return;
        }

        const atributoSelecionado = classificacaoOptions.find(opt => opt.value === value);

        const novoFiltros = {
            classificacaoid: atributoSelecionado?.key || '',
            classificacao: atributoSelecionado?.text || '',
        };

        setFiltrosClassificacaoAplica(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        // getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };

    const formatarHtml = (html) => {
        return beautifyHtml(html, {
            indent_size: 2,
            wrap_line_length: 80,
            preserve_newlines: true,
        });
    }

    const handleBuscar = async () => {
        const referenciaBusca = usarMesmoValor ? (selecionadoList ? getReferencia(selecionadoList) : '') : titulo;

        console.log('Buscar com filtros: ', filtrosFabricante.tecafabricanteid, filtrosMarca.tecamarcaid, filtrosLinha.tecalinhaid, filtrosClassificacao.classificacaoid, sku, produto, referenciaBusca, filtros.tecasecaoid);

        setSkuProdutoNome('');

        try {
            const conteudoBuscaList = await getConteudoBuscaAction({
                tecafabricanteid: filtrosFabricante.tecafabricanteid,
                tecamarcaid: filtrosMarca.tecamarcaid,
                tecalinhaid: filtrosLinha.tecalinhaid,
                classificacaoid: filtrosClassificacao.classificacaoid,
                sku: sku,
                produto: produto,
                titulo: referenciaBusca,
                tecasecaoid: filtros.tecasecaoid
            });

            if (sku?.trim() && (!conteudoBuscaList || conteudoBuscaList.length === 0)) {
                const skuInfo = await SearchSKUAction(sku.trim());
                setSkuProdutoNome(normalizeProductName(skuInfo?.[0]?.nomeprod));
            }
        } catch (error) {
            console.error('Erro ao buscar produtos para aplicar:', error);
            toast.error('Erro ao buscar produtos para aplicar!');
        }

    }

    const handleBuscarAplica = (titulo) => {



        getConteudoAplicaAction({
            tecafabricanteid: '',
            tecamarcaid: '',
            tecalinhaid: '',
            classificacaoid: filtrosClassificacaoAplica.classificacaoid,
            sku: skuAplica,
            produto: produtoAplica,
            titulo: titulo,
            tecasecaoid: filtros.tecasecaoid
        })
    }


    const handleSelecionar = (sku, titulo, conteudoid) => {

        console.log('handleSelecionar ->', { sku, titulo, conteudoid });

        setSelecionados(prev => {
            const exists = prev.some(i =>
                i.sku === sku && i.titulo === titulo
            );

            if (exists) {
                return prev.filter(i => !(i.sku === sku && i.titulo === titulo));
            }

            return [...prev, { sku, titulo }];
        });


        setSelectedConteudoIds(prev => {
            const existsId = prev.includes(conteudoid);

            if (existsId) {
                return prev.filter(id => id !== conteudoid);
            }

            console.log('adicionando conteudoid ->', selectedConteudoIds);

            return [...prev, conteudoid];
        });
    };



    const conteudolistFiltered = useMemo(() => {
        if (!buscaTitulo) return conteudolist;

        return conteudolist.filter(item =>
            getReferencia(item).toLowerCase().includes(buscaTitulo.toLowerCase())
        );
    }, [buscaTitulo, conteudolist]);


    const handleSearchBySku = async (sku) => {
        console.log('handleSearchBySku ->', sku);

        if (!sku?.trim()) {
            handleClearSearchBySku();
            return;
        }

        try {
            const secaoSkuList = await getSecaoSKUListAction(sku);

            setBuscaTitulo('');
            setSelecionado(null);
            setTituloSelecionado(null);
            setFiltros({
                tecasecaoid: '',
                tecasecao: ''
            });

            if (!secaoSkuList || secaoSkuList.length === 0) {
                toast.info('Nenhuma seção encontrada para este SKU.');
            }
        } catch (error) {
            console.error('Erro ao buscar secao por SKU:', error);
            toast.error('Erro ao buscar SKU!');
        }
    };

    const handleClearSearchBySku = () => {
        setSkuSearch('');
        setBuscaTitulo('');
        setFiltros({
            tecasecaoid: '',
            tecasecao: ''
        });
        setSelecionado(null);
        setTituloSelecionado(null);
    };

    const handleUpdateDesc = async () => {
        try {
            const referenciaSelecionada = getReferencia(selecionadoList);

            const dadosAtualizados = {
                ...conteudoEditForm,
                descricaolonga: conteudoHtml
            };

            console.log('conteudo:', dadosAtualizados, selectedConteudoIds, 'secao:', selecionadoList.tecasecaoid, 'referencia', referenciaSelecionada);
            const res = await postUpdateDescConteudo({
                tecaconteudoid: selecionadoList.tecaconteudoid,
                tecasecaoid: selecionadoList.tecasecaoid,
                titulo: referenciaSelecionada,
                descricao: conteudoHtml,
                ...dadosAtualizados
            });


            if (res?.[0]?.status === 'OK') {
                toast.success(res[0].message || 'Descrição atualizada com sucesso!');
            } else {
                toast.error(res?.[0]?.message || 'Erro ao atualizar a descrição!');
            }

        } catch (error) {
            toast.error('Erro ao atualizar descrição');
            console.error(error);
        }
    };

    const handleUpdateTitulo = async () => {
        const referenciaSelecionada = getReferencia(selecionadoList);

        console.log('update referencia ->', selectedConteudoIds, referenciaSelecionada)
        console.log('sku ->', sku)
        if (!sku?.trim()) {
            toast.error('Informe o SKU para aplicar a referência!');
            return;
        }

        if (!selecionado) {
            toast.error('Necessario selecionar uma referência!');
            return;
        }

        try {
            const res = await postUpdateTituloConteudo({
                sku: sku,
                json_itens: selectedConteudoIds,
                titulo: referenciaSelecionada
            });

            console.log('status ->', res?.[0]?.status);

            if (res?.[0]?.status === 'OK') {
                toast.success(res[0].message || 'Referência atualizada com sucesso!');
                setSelecionados([]);
                setSelectedConteudoIds([]);
                handleBuscarAplica(referenciaSelecionada);
            } else {
                toast.error(res?.[0]?.message || 'Erro ao atualizar a referência!');
            }

        } catch (error) {
            toast.error('Erro ao atualizar a referência!');
            console.error(error);
        }
    };

    const handleExcluirSku = async () => {
        // lógica para excluir o SKU
        console.log('Excluindo referencia:', tituloExcluir, 'conteudo:', conteudoExcluir);

        try {
            const res = await postDeleteTitulo({
                tecaconteudoid: conteudoExcluir,
                titulo: tituloExcluir
            });

            console.log('status ->', res?.[0]?.status);

            if (res?.[0]?.status === 'OK') {
                toast.success(res[0].message || 'Referência deletada com sucesso!');
                handleBuscarAplica(getReferencia(selecionadoList))
            } else {
                toast.error(res?.[0]?.message || 'Erro ao deletar a referência!');
            }

        } catch (error) {
            toast.error('Erro ao atualizar a referência!');
            console.error(error);
        }
        // Fechar o modal após a exclusão
        setOpenModalExcluirSKU(false);
    }



    return (
        <div>
            <ToastContainer />
            <Modal open={openModalExcluirSKU} onClose={() => setOpenModalExcluirSKU(false)}>
                <StyledModalHeader>
                    <ModalTitle>Confirmar exclusão da referência</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <p>Tem certeza de que deseja excluir a referência: <br /> <b>{tituloExcluir}</b> <br />da aplicação do conteúdo?</p>
                </StyledModalContent>
                <StyledModalActions>
                    <Button onClick={() => setOpenModalExcluirSKU(false)}>Cancelar</Button>
                    <Button loading={deletetituloloading} onClick={() => handleExcluirSku()} negative>Excluir</Button>
                </StyledModalActions>
            </Modal>
            <div style={{ width: '53.5%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ marginRight: '5px' }}>Seção:</span>
                <CustomDropdown
                    placeholder="Seção"
                    fluid
                    selection
                    clearable
                    search={searchSecaoOptions}
                    scrolling
                    loading={secaolistLoading}
                    options={activeSecaoOptions}
                    name="Seção"
                    value={filtros.tecasecaoid || ''}
                    onChange={handleChange}
                />
                <Input
                    style={{ marginLeft: '10px', }}
                    icon
                    placeholder="SKU"
                    value={skuSearch}
                    onChange={(e) => setSkuSearch(e.target.value)}
                    loading={secaoskulistLoading}
                >
                    <input />
                    <Icon
                        name="search"
                        circular
                        link
                        // style={{
                        //     backgroundColor: '#005EA3',
                        //     color: '#fff'
                        // }}
                        onClick={() => handleSearchBySku(skuSearch)}
                    />
                </Input>
                <Button
                    icon="close"
                    title="Limpar busca por SKU"
                    onClick={handleClearSearchBySku}
                    disabled={!skuSearch && !buscaTitulo}
                    style={{ marginLeft: '5px' }}
                />
            </div>
            <div style={{ width: '100%', display: 'flex', marginTop: '10px' }}>
                <span style={{ marginRight: '3px' }}>Referência:</span>
                <span style={{ width: '100%' }}>
                    <div style={{ border: '1.5px solid #DEDEDF', width: '52%', height: '200px', overflow: 'hidden', overflowY: 'auto', borderRadius: '4px', padding: '8px', display: 'flex', flexDirection: 'column', }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                            {adicionar === true ? (
                                <Input style={{ width: '300px' }} placeholder='Adicionar nova referência' onChange={e => setNovoTitulo(e.target.value)} />
                            ) : (
                                <span style={{ color: 'grey' }}>Adicionar nova referência</span>
                            )}
                            <div>
                                {adicionar === true ? (
                                    <ActionButtonSelect loading={addtituloloading} onClick={handleSaveTitulo}>Salvar</ActionButtonSelect>
                                ) : (
                                    null
                                )}
                                <ActionButtonSelect selected={adicionar} onClick={() => setAdicionar(!adicionar)}>{adicionar === true ? 'Cancelar' : 'Adicionar'}</ActionButtonSelect>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                            <Input value={buscaTitulo} onChange={e => setBuscaTitulo(e.target.value)} style={{ width: '300px' }} input={{ style: { border: 'none', boxShadow: 'none', background: 'transparent' } }} placeholder='Pesquisar referência' />
                        </div>
                        {conteudolistLoading ? (
                            <Loader active inline="centered">Carregando...</Loader>
                        ) : (
                            conteudolistFiltered.map((item) =>


                                <>

                                    <div key={item.tecaconteudoid} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                        <span>{getReferencia(item) || 'Sem referência'}{' '}
                                            {/* {editarTituloId !== item.tecaconteudoid ? (
                                                <Icon
                                                    style={{ color: '#005EA3', cursor: 'pointer' }}
                                                    name="edit"
                                                    size="small"
                                                    onClick={() => setEditarTituloId(item.tecaconteudoid)}
                                                />
                                            ) : (
                                                <>
                                                    <Icon
                                                        style={{ color: 'green', cursor: 'pointer' }}
                                                        name="check"
                                                        size="small"
                                                        onClick={() => setEditarTituloId(null)}
                                                    />
                                                    <Icon
                                                        style={{ color: 'red', cursor: 'pointer' }}
                                                        name="close"
                                                        size="small"
                                                        onClick={() => setEditarTituloId(null)}
                                                    />
                                                </>
                                            )} */}
                                        </span>
                                        <ActionButtonSelect selected={selecionado === item.tecaconteudoid} onClick={() => handleSelect(item.tecaconteudoid, getReferencia(item))} >{selecionado === item.tecaconteudoid ? 'Cancelar' : 'Escolher'}</ActionButtonSelect>
                                    </div>
                                </>

                            )

                        )}

                        {
                            conteudolist.length === 0 && !conteudolistLoading && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '6px' }}>
                                    <span>Nenhuma referência encontrada...</span>
                                </div>
                            )
                        }

                    </div>
                </span>
            </div>
            {selecionadoList && <hr style={{ marginTop: '20px', marginBottom: '20px' }} />}

            {conteudodetalhesLoading === true && <Loader active />}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'flex-end', gap: '8px', marginBottom: '10px' }}>
                    {editar === false ? (
                        <Button onClick={() => setEditar(true)} color='green' size='tiny'>
                            Editar
                        </Button>
                    ) : (
                        <>
                            <Button onClick={handleCancelarEdicaoConteudo} color='red' size='tiny'>
                                Cancelar
                            </Button>
                            <Button loading={updatedescloading} onClick={() => handleUpdateDesc()} color='blue' size='tiny'>
                                Salvar
                            </Button>
                        </>
                    )}
                </div>
            )}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between' }}>

                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>Descrição curta:</span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Descrição principal"
                        value={conteudoEditForm.descricaocurta}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('descricaocurta', e.target.value)}
                    />
                </div>
            )}



            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row', marginTop: '10px' }}>

                    <span style={{ display: 'flex', flexWrap: 'nowrap', width: '20%', marginBottom: '10px' }}>Descrição longa:</span>

                    <div style={{ width: '100%' }}>

                        {editar === true ? (
                            <>
                                <Button size='tiny' onClick={() => { setHtmlMode(!htmlMode); setConteudoHtml(formatarHtml(conteudoHtml)) }}>
                                    {htmlMode ? 'Editor HTML' : 'Código HTML'}
                                </Button>

                                {htmlMode ? (
                                    <TextArea
                                        style={{
                                            width: '100%',
                                            height: '200px',
                                            border: '1px solid #dededf',
                                            borderRadius: '4px',
                                            padding: '10px',
                                            marginTop: '10px'
                                        }}
                                        placeholder="Descrição longa"
                                        value={conteudoHtml}
                                        onChange={(e) => {
                                            setConteudoHtml(e.target.value);
                                            console.log('valor digitado ->', e.target.value);
                                        }}
                                    />
                                ) : (
                                    <ReactQuill
                                        style={{ width: '100%', marginTop: '10px', marginBottom: '10px', borderRadius: '6px' }}
                                        // theme="snow"
                                        value={conteudoHtml}
                                        onChange={(val) => setConteudoHtml(val)}
                                    />
                                )}
                            </>
                        ) : (
                            <ReactQuill
                                style={{ width: '100%', marginTop: '10px', marginBottom: '10px', borderRadius: '6px' }}
                                // theme="snow"
                                value={conteudoHtml}
                                readOnly
                                onChange={(val) => setConteudoHtml(val)}
                            />
                        )}

                    </div>
                </div>
            )}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>

                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%', }}>URL PDF:</span>
                    <Input
                        style={{ width: '100%', }}
                        placeholder="URL PDF"
                        value={conteudoEditForm.urlpdf}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('urlpdf', e.target.value)}
                    />
                </div>
            )}


            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>

                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%', }}>URL video:</span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="URL video"
                        value={conteudoEditForm.urlvideo}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('urlvideo', e.target.value)}
                    />
                </div>
            )}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>

                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%', }}>URL foto:</span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="URL foto"
                        value={conteudoEditForm.urlfoto}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('urlfoto', e.target.value)}
                    />
                </div>
            )}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>

                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%', }}>SVG icone:</span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="SVG icone"
                        value={conteudoEditForm.iconesvg}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('iconesvg', e.target.value)}
                    />
                </div>
            )}


            {/* Video embed */}
            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Vídeo embed:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Vídeo embed"
                        value={conteudoEditForm.videoembed}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('videoembed', e.target.value)}
                    />
                </div>
            )}


            {/* Texto alternativo */}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Texto alternativo:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Texto alternativo"
                        value={conteudoEditForm.textoalternativo}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('textoalternativo', e.target.value)}
                    />
                </div>
            )}


            {/* Legenda */}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Legenda:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Legenda"
                        value={conteudoEditForm.legenda}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('legenda', e.target.value)}
                    />
                </div>
            )}


            {/* Legenda descritiva */}

            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Legenda descritiva:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Legenda descritiva"
                        value={conteudoEditForm.legendadescritiva}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('legendadescritiva', e.target.value)}
                    />
                </div>
            )}


            {/* Ordem */}
            {selecionadoList && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Ordem:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Ordem"
                        value={conteudoEditForm.ordem}
                        readOnly={!editar}
                        onChange={(e) => handleConteudoFieldChange('ordem', e.target.value)}
                    />
                </div>
            )}


            {/* Última alteração */}
            {selecionadoList?.dtultalt && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Última alteração:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Última alteração"
                        value={selecionadoList?.dtultalt ? moment(selecionadoList?.dtultalt).format("DD/MM/YYYY hh:mm:ss") : ''}
                        readOnly={!editar}
                    />
                </div>
            )}


            {/* Alterado produto */}
            {selecionadoList?.usuarioultalt && (
                <div style={{ width: '50%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', width: '20%' }}>
                        Último usuario:
                    </span>
                    <Input
                        style={{ width: '100%' }}
                        placeholder="Última alteração"
                        value={selecionadoList?.usuarioultalt !== 0 && selecionadoList?.usuarioultalt !== null ? selecionadoList?.usuarioultalt : ''}
                        readOnly={!editar}
                    />
                </div>

            )}




            <div style={{ display: 'flex', marginTop: '30px', alignItems: 'center', justifyContent: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>APLICAÇÃO</p>
            </div>
            <hr style={{ marginBottom: '20px' }} />

            <div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'normal', width: '100%' }}>
                        <span style={{ marginRight: '20px' }}>
                            Seção:
                        </span>
                        <CustomDropdown
                            style={{ width: '81.5%' }}
                            placeholder="Seção"
                            fluid
                            selection
                            clearable
                            search
                            // options={linhaOptions}
                            name="Seção"
                            options={secaoOptions}
                            value={filtros.tecasecaoid}
                            disabled={true}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', marginLeft: '20px' }}>
                        <span style={{ marginRight: '20px' }}> Referência:</span>
                        <Input style={{ width: '100%' }}
                            placeholder="Referência"
                            value={getReferencia(selecionadoList)}
                            disabled
                            readOnly />
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, gap: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>SKU:</span>
                        <Input
                            value={skuAplica}
                            onChange={(e) => setSkuAplica(e.target.value)}
                            placeholder="SKU" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Produto:</span>
                        <Input
                            value={produtoAplica}
                            onChange={(e) => setProdutoAplica(e.target.value)}
                            placeholder="Produto" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Classificação:</span>
                        <CustomDropdown
                            style={{ width: '80%' }}
                            placeholder="Classificação"
                            fluid
                            selection
                            clearable
                            search
                            options={classificacaoOptions}
                            name="Classificacao"
                            noResultsMessage="Nenhuma Classificação encontrada"
                            value={classificacaoOptions.classificacaoid}   // <--- chave correta
                            onChange={handleChangeClassificacaoAplica}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            onClick={() => handleBuscarAplica(getReferencia(selecionadoList))}
                            style={{ backgroundColor: '#0078d7', color: '#fff' }}>Buscar <Icon name="search" style={{ marginLeft: '5px' }} /></Button>
                    </div>
                </div>

            </div>

            <Container>
                <Table>
                    <thead>
                        <tr>
                            <Th>SKU</Th>
                            <Th>Produto</Th>
                            <Th>Referência</Th>
                            <Th></Th>
                        </tr>
                    </thead>
                    <tbody>
                        {conteudoaplicaLoading === false ? (
                            conteudoaplica.map(item => (
                                <tr>
                                    <Td>{item.sku}</Td>
                                    <Td>{normalizeProductName(item.nomeproduto)}</Td>
                                    <Td>
                                        <Status>
                                            {getReferencia(item)}
                                        </Status>
                                    </Td>
                                    <Td style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <ActionButton onClick={() => { setOpenModalExcluirSKU(true); setTituloExcluir(getReferencia(item)); setConteudoExcluir(item.tecaconteudoid) }}>
                                            <Icon name="trash alternate outline" /> Excluir
                                        </ActionButton>
                                    </Td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <Td></Td>
                                <Td>
                                    <Loader style={{ marginLeft: '100px' }} active inline="centered">Carregando...</Loader>
                                </Td>
                            </tr>
                        )}

                        {conteudoaplica.length === 0 && (
                            <Td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                Nenhum item disponível.
                            </Td>
                        )}
                    </tbody>
                </Table>
            </Container>


            <hr style={{ marginTop: '20px' }} />

            <div style={{ backgroundColor: '#E1E1E1', margin: '-10px', padding: '10px', borderRadius: '8px' }}>
                {/* FILTROS PARA BUSCA */}
                <div>
                    <p style={{ color: '#102E3E', fontWeight: 'bold' }}>Busca para identificar novos produtos a serem APLICADOS</p>
                </div>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                        <span style={{ marginLeft: '-10px' }}>
                            Fabricante:{' '}
                        </span>
                        <CustomDropdown
                            style={{ width: '80%' }}
                            placeholder="Fabricante"
                            fluid
                            selection
                            clearable
                            search
                            options={fabricanteOptions}
                            name="Fabricante"
                            value={filtrosFabricante.tecafabricanteid || ''}   // <--- chave correta
                            onChange={handleChangeFabricante}
                            noResultsMessage="Nenhum Fabricante encontrado"
                        />
                    </div>
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px' }}>
                            Marca:
                        </span>
                        <CustomDropdown
                            style={{ width: '80%' }}
                            placeholder="Marca"
                            fluid
                            selection
                            clearable
                            search
                            options={marcaOptions}
                            name="Marca"
                            disabled={filtrosFabricante.tecafabricanteid ? false : true}
                            value={filtrosFabricante.tecafabricanteid ? marcaOptions.tecamarcaid : ''}   // <--- chave correta
                            onChange={handleChangeMarca}
                            noResultsMessage="Nenhuma Marca encontrada"
                        />
                    </div>
                </div>
                <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <span style={{ marginRight: '24px' }}> Linha:</span>
                        <CustomDropdown
                            style={{ width: '80%' }}
                            placeholder="Linha"
                            fluid
                            selection
                            clearable
                            search
                            options={linhaOptions}
                            name="Linha"
                            disabled={filtrosMarca.tecamarcaid ? false : true}
                            value={filtrosMarca.tecamarcaid ? linhaOptions.tecalinhaid : ''}   // <--- chave correta
                            onChange={handleChangeLinha}
                            noResultsMessage="Nenhuma linha com produtos encontrada"
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <span style={{ marginLeft: '-40px', marginRight: '5px' }}>Classificação: </span>
                        <CustomDropdown
                            style={{ width: '80%' }}
                            placeholder="Classificação"
                            fluid
                            selection
                            clearable
                            search
                            options={classificacaoOptions}
                            name="Classificacao"
                            noResultsMessage="Nenhuma Classificação encontrada"
                            value={classificacaoOptions.classificacaoid}   // <--- chave correta
                            onChange={handleChangeClassificacao}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, gap: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>SKU:</span>
                        <Input
                            value={sku}
                            onChange={(e) => setSku(e.target.value)}
                            placeholder="SKU" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Produto:</span>
                        <Input
                            value={produto}
                            onChange={(e) => setProduto(e.target.value)}
                            placeholder="Produto" />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Referência:</span>
                        <Input
                            style={{ width: '400px' }}
                            placeholder="Referência"
                            value={usarMesmoValor ? getReferencia(selecionadoList) : titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            disabled={usarMesmoValor}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Mesma referência:</span>
                        <Checkbox
                            checked={usarMesmoValor}
                            onChange={(e, data) => setUsarMesmoValor(Boolean(data.checked))}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            onClick={() => handleBuscar()}
                            style={{ backgroundColor: '#0078d7', color: '#fff' }}>Buscar <Icon name="search" style={{ marginLeft: '5px' }} /></Button>
                    </div>
                </div>


                <Container>
                    <Table style={{ backgroundColor: '#E1E1E1' }}>
                        <thead style={{ backgroundColor: '#E1E1E1' }}>
                            <tr>
                                <Th>SKU({conteudobusca.length})</Th>
                                <Th>Produto</Th>
                                <Th>Referência atual</Th>
                                <Th>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <span style={{ marginRight: 5, width: '100px' }}>Selecionar Tudo</span>
                                        <Checkbox
                                        // checked={todosSelecionados}
                                        // onChange={handleSelecionarTodos}
                                        // disabled={dataFiltrada.length === 0}
                                        />
                                    </div>
                                </Th>
                            </tr>
                        </thead>


                        <tbody style={{ backgroundColor: '#E1E1E1' }}>
                            {conteudobuscaLoading === false ? (
                                conteudobusca.map((item, index) => (
                                    <Tr
                                        key={`${item.sku}-${index}`}
                                        selected={selecionados.find(i => i.sku === item.sku && i.titulo === getReferencia(item))}
                                    >


                                        <Td>{item.sku}</Td>
                                        <Td>{normalizeProductName(item.nomeproduto)}</Td>
                                        <Td style={{ width: '500px' }}>
                                            <Status
                                            // valorParaInput={valorParaInput} 
                                            // value={item.tecaatributovalor}
                                            >
                                                {getReferencia(item) || '<vazio>'}
                                            </Status>
                                        </Td>


                                        <Td>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ActionButtonSelect
                                                    selected={selecionados.find(i => i.sku === item.sku && i.titulo === getReferencia(item)) ? true : false}
                                                    onClick={() => {
                                                        if (!selecionado) {
                                                            toast.error('Necessario selecionar uma referência!');
                                                            return;
                                                        }

                                                        handleSelecionar(item.sku, getReferencia(item), selecionado);
                                                    }}
                                                >
                                                    {selecionados.find(i => i.sku === item.sku && i.titulo === getReferencia(item)) ? 'Cancelar' : 'Selecionar'}
                                                </ActionButtonSelect>
                                            </div>
                                        </Td>
                                    </Tr>
                                ))

                            ) : (
                                <Tr>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td>
                                        <Loader active inline="centered">Carregando...</Loader>
                                    </Td>
                                </Tr>
                            )}

                            {conteudobusca.length === 0 && !conteudobuscaLoading && (
                                <>
                                    {sku && (
                                        <Tr
                                            key={sku}
                                            selected={selecionados.find(i => i.sku === sku)}
                                        >


                                            <Td>{sku}</Td>
                                            <Td>{skuProdutoNome || '-'}</Td>
                                            <Td style={{ width: '500px' }}>
                                                <Status
                                                >
                                                    {'<vazio>'}
                                                </Status>
                                            </Td>


                                            <Td>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ActionButtonSelect
                                                        selected={selecionados.find(i => i.sku === sku) ? true : false}
                                                        onClick={() => {
                                                            tituloSelecionado && selecionado ? (

                                                                handleSelecionar(sku, tituloSelecionado, selecionado)
                                                            ) : (
                                                                toast.error('Necessario selecionar uma referência!!')
                                                            )
                                                        }}
                                                    >
                                                        {selecionados.find(i => i.sku === sku) ? 'Cancelar' : 'Selecionar'}
                                                    </ActionButtonSelect>
                                                </div>
                                            </Td>
                                        </Tr>
                                    )}

                                    <Td
                                        colSpan={5}
                                        style={{ textAlign: 'center', padding: 20, color: '#666' }}
                                    >
                                        Nenhum item disponível.
                                    </Td>
                                </>
                            )}

                        </tbody>
                    </Table>
                </Container>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <Button
                        color="blue"
                        onClick={() => handleUpdateTitulo()}
                        loading={updatetituloloading}
                        disabled={selecionados.length === 0}
                    >
                        Aplicar produtos selecionados <Icon name='long arrow alternate up' />
                    </Button>
                </div>
            </div>

        </div>



    )
}

const mapStateToProps = (state) => ({
    secaolist: state.EspacoTecaReducer.secaolist,
    secaolistLoading: state.EspacoTecaReducer.secaolistLoading,
    secaoskulist: state.EspacoTecaReducer.secaoskulist,
    secaoskulistLoading: state.EspacoTecaReducer.secaoskulistLoading,
    conteudolist: state.EspacoTecaReducer.conteudolist,
    conteudolistLoading: state.EspacoTecaReducer.conteudolistLoading,
    conteudodetalhes: state.EspacoTecaReducer.conteudodetalhes,
    conteudodetalhesLoading: state.EspacoTecaReducer.conteudodetalhesLoading,
    fabricanteList: state.EspacoTecaReducer.fabricanteList,
    fabricanteListLoading: state.EspacoTecaReducer.fabricanteListLoading,
    classificacaoList: state.EspacoTecaReducer.classificacaoList,
    classificacaoListLoading: state.EspacoTecaReducer.classificacaoListLoading,
    marcaList: state.EspacoTecaReducer.marcaList,
    marcaListLoading: state.EspacoTecaReducer.marcaListLoading,
    linhalist: state.EspacoTecaReducer.linhalist,
    linhalistLoading: state.EspacoTecaReducer.linhalistLoading,
    conteudobusca: state.EspacoTecaReducer.conteudobusca,
    conteudobuscaLoading: state.EspacoTecaReducer.conteudobuscaLoading,
    conteudoaplica: state.EspacoTecaReducer.conteudoaplica,
    conteudoaplicaLoading: state.EspacoTecaReducer.conteudoaplicaLoading,
    updatedesc: state.EspacoTecaReducer.updatedesc,
    updatedescloading: state.EspacoTecaReducer.updatedescloading,
    updatetitulo: state.EspacoTecaReducer.updatetitulo,
    updatetituloloading: state.EspacoTecaReducer.updatetituloloading,
    addtitulo: state.EspacoTecaReducer.addtitulo,
    addtituloloading: state.EspacoTecaReducer.addtituloloading,
    deletetitulo: state.EspacoTecaReducer.deletetitulo,
    deletetituloloading: state.EspacoTecaReducer.deletetituloloading,
});

export default withRouter(connect(mapStateToProps, {
    getSecaoListAction,
    getSecaoSKUListAction,
    getConteudoListAction,
    getConteudoDetalhesAction,
    getClassificacaoListAction,
    getFabricanteListAction,
    getMarcaListAction,
    getLinhaListAction,
    getConteudoBuscaAction,
    getConteudoAplicaAction,
    postUpdateDescConteudo,
    postUpdateTituloConteudo,
    postNewTitulo,
    postDeleteTitulo,
    SearchSKUAction
})(Conteudo));
